export default "__VITE_ASSET__CzsQH$wH__"